import { STATION_LOGO } from '@/lib/images'

interface LogoProps {
  className?: string
}

function Logo({ className = '' }: LogoProps) {
  return (
    <img
      src={STATION_LOGO}
      alt="Bonita FM 87,9"
      className={`h-[52px] w-auto max-w-[220px] object-contain object-left sm:h-[64px] sm:max-w-[280px] ${className}`}
      decoding="async"
    />
  )
}

export default Logo
